export interface CalendarArrivalWindowChange {
  notification?: import('@/hooks/jobs/useScheduleChangeNotification').ScheduleNotificationChoice;
  presetId?: string;
  useVisitTime?: boolean;
  expectedUpdatedAt: string;
}
export interface CalendarArrivalWindowConflict {
  appointmentId?: string;
  timezone: string;
  jobTypeId?: string | null;
  businessUnitId?: string | null;
  expectedUpdatedAt: string;
  currentStartAt: string | null;
  currentEndAt: string | null;
  currentDate: string | null;
  proposedStartAt: string;
  proposedEndAt: string;
}
export function parseCalendarArrivalWindowConflict(
  error: unknown,
): CalendarArrivalWindowConflict | null {
  if (!error || typeof error !== 'object') return null;
  const candidate = error as {
    status?: number;
    data?: unknown;
    response?: { status?: number; data?: unknown };
  };
  if ((candidate.status ?? candidate.response?.status) !== 409) return null;
  const body = (candidate.data ?? candidate.response?.data) as
    | { code?: string; metadata?: { arrivalWindowChange?: CalendarArrivalWindowConflict } }
    | undefined;
  const conflict = body?.metadata?.arrivalWindowChange;
  return body?.code === 'PLAN_OUTSIDE_PROMISE' &&
    conflict?.timezone &&
    conflict.expectedUpdatedAt &&
    conflict.proposedStartAt &&
    conflict.proposedEndAt
    ? conflict
    : null;
}
